define((require) => {
    "use strict";

    var DashboardController                     = require("ui/dashboard/DashboardController"),
        Preconditions                           = require("shared/util/Preconditions"),
        ProjectDashboardView                    = require("ui/projects/ProjectDashboardView"),
        ProjectDashboardConfiguration           = require("ui/dashboard/ProjectDashboardConfiguration"),
        ProjectModel                            = require("ui/editor/project/ProjectModel"),
        EditorEvents                            = require("shared/services/EditorEvents"),
        Backbone                                = require("backbone"),
        ProjectSelector                         = require("ui/projects/ProjectSelector"),
        _                                       = require("underscore"),
        LoggedIn                                = require("shared/security/LoggedIn"),
        ProjectContext                          = require("ui/editor/project/ProjectContext"),
        LoggedInUserState                       = require("shared/ui/user/LoggedInUserState");

    /**
     *
     *
     * @class ProjectDashboardController
     */
    return DashboardController.extend("ProjectDashboardController", {

        dashboardView: ProjectDashboardView,

        /**
         * Explicitly define dashboard view specific options, in order to construct the project context.
         *
         * @param  {*} options The current options.
         * @return {Promise}   A promise that resolves with the options passed to the actual dashboard view.
         */
        dashboardViewOptions: function(options) {
            return this.__super()
                .then(() => {
                    return options.project.fetch();
                })
                .then(() => {
                    var project = options.project,
                        projectContextOptions = {
                            project: project
                        };

                    return _.extend(options, {
                        projectContext: new ProjectContext(projectContextOptions)
                    });
                });
        },

        config: ProjectDashboardConfiguration,

        /**
         * @type {ProjectModel}
         */
        _project: null,

        /**
         * @type {ProjectContext}
         */
        _projectContext: null,

        onBeforeDashboardShow: function(options) {
            // Store the project context in order to dispose it when the controller is closed.
            this._projectContext = options.projectContext;
        },

        /**
         * Shows the project dashboard.
         *
         * @param  {*} options The dashboard options, including the current project model.
         *                     @cfg {ProjectModel} project The current project model.
         *                     @cfg {DashboardTabConfiguration} tab The initial dashboard tab.
         */
        show: function(options) {
            Preconditions.checkArgument(options.project, "A project model must be specified");

            var project = options.project,
                controllerOptions = _.extend(options, {
                    // Re-create the dashboard view when the project changes...
                    reset: options.project !== this._project
                });

            // Remove any previously added listeners (see below) - we need this when navigating between
            // projects (remain on the project dashboard), as this will not close *this* controller, i.e. listener(s)
            // will not be removed.
            this.stopListening(this._project);

            this._project = project;

            // If the current project is deleted/destroyed during editing (i.e. via the project selector) - we'll
            // navigate to the dashboard but keep the project selector open
            this.listenToOnce(this._project, "destroy", (collection, model, options) => {
                if (options.source === "projectSelector") {
                    Backbone.history.navigate("", true);
                    ProjectSelector.toggleProjectSelector(true);
                }
            });

            ProjectDashboardConfiguration.context({project: project});

            this.__super(controllerOptions);
        },

        /**
         * Creates a new project and navigates to that.
         *
         * @return {Promise} Promise that resolves when the project has been created.
         */
        createProject: function() {
            var principal = LoggedIn.principal(),
                model = new ProjectModel({
                    createdBy: principal.get("userId"),
                    companyId: principal.get("companyId")
                });

            return model.save()
                .then(() => {
                    var projects = LoggedInUserState.get("projects");
                    projects.add(model);

                    var eventProperties = {
                        projectId: model.get("id"),
                        triggerOrigin: "CreateNewProjectArea"
                    };

                    EditorEvents.trigger(EditorEvents.constants.CREATE_PROJECT, eventProperties);

                    // TODO: Let the router do the navigation? (It's the only one using this method).
                    Backbone.history.navigate("project/" + model.get("id"), {trigger: true, replace: true});
                });
        },

        onClose: function() {
            this.__super();

            this._projectContext.dispose();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/ProjectDashboardController.js